enum FileTag {
	BARGING_LETTER_FRONT = 'barging-letter-front',
	BARGING_LETTER_REAR = 'barging-letter-rear',
	MEASUREMENT_CERTIFICATE = 'measurement-certificate',
	NOMINATION = 'nomination',
	TIME_SHEET = 'time-sheet',
	TRANSPORT_ORDER = 'transport-order',
	STOWAGE_PLAN_STABILITY_CALCULATION = 'stowage-plan-stability-calculation',
	LOADING_PLAN = 'loading-plan',
	DISCHARGE_PLAN = 'discharge-plan',
	DECLARATION_OF_RELEASE = 'declaration-of-release',
	ADN_CHECKLIST = 'adn-checklist',
	VOYAGE_PREPARATION = 'voyage-preparation',
	VESSEL_DATA = 'vessel-data',
	LETTER_OF_PROTEST = 'letter-of-protest',
	CUSTOMS_DOCUMENT = 'customs-document',
	TEMPERATURE_REGISTRATION = 'temperature-registration',
	EMPTY_VESSEL_TRANSPORT_DOCUMENT = 'empty-vessel-transport-document',
	LOADING_DOCUMENT = 'loading-document',
	UNLOADING_DOCUMENT = 'unloading-document',
	BILL_OF_LADING = 'bill-of-lading',
	BUILDING_MATERIALS = 'building-materials',
	BUILDING_MATERIALS_LOADING = 'building-materials-loading',
	ADVISING = 'advising',
	HOPPER_MEASUREMENT = 'hopper-measurement',
	LCI_REPORT = 'lci-report',
	INVOICE = 'invoice',
	CONTAINER_MANIFEST = 'container-manifest',
	CHLORIDE_INSPECTION_REPORT = 'chloride-inspection-report',
	PURCHASE_ORDER = 'purchase-order',
	PRODUCT_ANALYSIS = 'product-analysis',
	ORDER = 'orders',
	OTHER = 'other'
}

export default FileTag
